// extracted by mini-css-extract-plugin
export default {"tableCard":"TableSection_tableCard__ci6RD"};